import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import CouponProp from './couponProp';
import VoucherProp from './voucherProp';
import GameTypeProp from './gameTypeProp';

const propType = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  journeyAssigned: PropTypes.bool,
  isDefault: PropTypes.bool,
  image: PropTypes.shape(ImageProp.propType),
  challenges: PropTypes.shape({
    isStatic: PropTypes.bool,
    unity: PropTypes.string,
    scoreTarget: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scoreApproved: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scoreRejected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isViewSimplified: PropTypes.bool,
  }),
  progress: PropTypes.number,
  candidates: PropTypes.number,
  gameType: PropTypes.shape(GameTypeProp.propType).isRequired,
  points: PropTypes.number,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  coupon: PropTypes.shape(CouponProp.propType),
  voucher: PropTypes.shape(VoucherProp.propType),
  rewardCoins: PropTypes.shape({
    score: PropTypes.number,
    winner: PropTypes.number,
  }),
  rewardLead: PropTypes.shape({
    points: PropTypes.number,
    coins: PropTypes.number,
    coupon: PropTypes.shape({}),
  }),
};

export default { propType };
